export default __webpack_public_path__ + "static/media/jellyfin.356fc272.png";